import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import FastfoodIcon from '@material-ui/icons/Fastfood';
import LaptopMacIcon from '@material-ui/icons/LaptopMac';
import HotelIcon from '@material-ui/icons/Hotel';
import RepeatIcon from '@material-ui/icons/Repeat';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import DoneOutline from '@material-ui/icons/DoneAllOutlined';
import { Checkbox, Tooltip } from '@material-ui/core';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: '6px 16px'
  },
  secondaryTail: {
    backgroundColor: theme.palette.secondary.main
  }
}));

export default function CustomizedTimeline (props) {
  const classes = useStyles();
  const [openPopup, setOpenPopup] = React.useState(false);

  return (<>
      <Timeline align="alternate">
          {props.trackerTimeLineData && props.trackerTimeLineData.map((item, i) => (
              <TimelineItem key={'timeline-item' + i}>
        <TimelineOppositeContent>
          <Typography variant="body2" color="textPrimary">
            {item.completedOn && item.completedOn !== '0001-01-01T00:00:00' && moment(item.completedOn).format('MM/DD/YYYY hh:mm')}
          </Typography>
        </TimelineOppositeContent>
        <TimelineSeparator>
                      <TimelineDot className={item.isCompleted === true ? 'completed' : item.isApplicable === false ? 'notapplicable' : 'notstarted'}>
                          {item.isCompleted === true || item.isApplicable === false
                            ? <DoneOutline fontSize="small" style={{ color: 'green' }}
                      onClick={(event) => { console.log(item); props.callbackOnchange && props.callbackOnchange(item); }}></DoneOutline>
                            : <Checkbox checked={false} onClick={(event) => { console.log(item); props.callbackOnchange && props.callbackOnchange(item); }}></Checkbox>
                          }
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>
                  <Tooltip title={item.completedBy ? 'Updated By: ' + item.completedBy : ''} >
          <Paper elevation={3} className={classes.paper} aria-label="add">
                    <Typography variant="h6" component="h3" color="textPrimary" >
             {item.stepName}
            </Typography>
            <Typography variant="caption" color="textPrimary">{item.isApplicable === true ? item.comments : 'Not Applicable'}</Typography>
                  </Paper>
                  </Tooltip>
        </TimelineContent>
      </TimelineItem>

          ))
          }
    </Timeline>
    </>
  );
}
